import { InjectionToken } from '@angular/core';

import { CollectionModuleConfiguration } from './models/configuration';

export const CollectionConfigurationService = new InjectionToken<CollectionModuleConfiguration>('CollectionModuleConfiguration');
